<template>
    <div class="root" data-testid="activity-overlay">
        <div :class="{'background':true, 'translucent':translucent}" />
        <circle-spinner size="64px" color="#2A3241" stroke="6.4px"/>
    </div>
</template>

<script>
export default {
    name: "ActivityOverlay",
    props: {
        translucent: {
            type: Boolean,
            default: false
        }
    },
}
</script>

<style scoped lang="scss">
@import "../../../sass/web/_variables.scss";

.root,
.background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.root {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.background {
    background-color: $white;
}

.translucent {
    opacity: 0.8;
}
</style>